// tslint:disable
import {ElementRef, Injectable, ViewChild} from '@angular/core';
import {CpcWebApiService} from "../cpc-web-api.service";
import 'rxjs/add/operator/toPromise';
import {Subject} from "rxjs/Subject";
import {DomSanitizer} from "@angular/platform-browser";
import { CpcSysInfoService } from "../cpc-sys-info.service";
import {tryCatch} from 'rxjs/util/tryCatch';

@Injectable()
export class ModMenuService {

  /** 标签页开始 ------------------------------------ */
  public selectedMenu = new Mod();  //左侧栏的菜单所属模块
  public sLeftMenuSub: Subject<Mod> = new Subject();  //左侧栏的菜单所属模块观察对象
  public TopBar: tabMenu[] = new Array<tabMenu>();  //标签页对象
  public TopBarSub: Subject<tabMenu[]> = new Subject(); //标签页观察对象
  public selectedTab: tabMenu;  //当前所选标签页
  public sTabSub: Subject<tabMenu> = new Subject(); //当前所选标签页观察对象
  public selectedQueue: tabMenu[] = new Array();  //所选标签页队列
  public  IsSpread:boolean = true; // leftmenu是否收缩
  public  docTempOfUsers:any; // 文档管理 的文件模板
  public  menuOfUsers:any; // 用户能看到的菜单；
  public changeOrgSub:Subject<string> = new Subject();//切换组织的订阅
  constructor(private webapi: CpcWebApiService, private sysInfo: CpcSysInfoService, private su: DomSanitizer) {

    //设置window.CreateTab方法..用以支持在frame中直接创建标签页
    let ms = this;
    (<any>window).CreateTab = function (tabid, tabname, url, type) {
      if(url.trim() == 'EmailComponent'){
        ms.createEmailTab();
      }
      else if(url.trim() == 'WfComponent'){
        ms.createWfListTab();
      }
      else if (tabid && url && tabname) {
        const tabmenu = new tabMenu(tabname, tabid, type ? type : 'frameOpen', 'FrameConComponent');
        tabmenu.tabUrl = url;
        ms.addTabMenu(tabmenu);
      }
    };
  }

  /**
   * 创建邮箱的标签页
   *
   */
  createEmailTab(){
    //邮件模块 的modtag==13  根据这个去查找 邮件的modid  PS：有可能找不到 找不到时候modid=13
    let tabId = "13";
    let tabName = "我的邮箱";
    let tabType = "cpcmod";
    let mods:any;
    if(this.mods&& this.mods.length>0){
      mods = JSON.parse(JSON.stringify(this.mods));
    }
    else{
      mods = JSON.parse(window.sessionStorage.getItem('mods'))?JSON.parse(window.sessionStorage.getItem('mods')).mods:[];
    }
    let item = this.filterItemFromMods(mods,'EmailComponent');
    if(item){
      if(item.menuid){
        tabId = item.menuid;
        tabName = item.menuname;
        tabType = "cpcmenu";
      }
      else if(item.modid){
        tabId = item.modid;
        tabName = item.modname;
        tabType = "cpcmod";
      }
    }

    let tabmenu = new tabMenu(tabName, tabId, tabType);
    tabmenu.tabUrl = '/websystem/oa/email/pc/index.jsp';
    tabmenu.componentName = "FrameConComponent";
    let comIns = this.addTabMenu(tabmenu);
    return comIns;//返回 创建的选项卡实例 需要 自取
  }
  /**
   * 创建流程列表的标签页
   *
   */
  createWfListTab(){
    //邮件模块 的modtag==13  根据这个去查找 邮件的modid  PS：有可能找不到 找不到时候modid=13
    let tabId = "892";
    let tabName = "我的流程";
    let tabType = "cpcmod";
    let mods:any;
    if(this.mods&& this.mods.length>0){
      mods = JSON.parse(JSON.stringify(this.mods));
    }
    else{
      mods = JSON.parse(window.sessionStorage.getItem('mods'))?JSON.parse(window.sessionStorage.getItem('mods')).mods:[];
    }


    let item = this.filterItemFromMods(mods,'WfComponent');
    if(item){
      if (item.menuid) {
        tabId = item.menuid;
        tabName = item.menuname;
        tabType = 'cpcmenu';
      } else if (item.modid) {
        tabId = item.modid;
        tabName = item['langmodname'];
        tabType = 'cpcmod';
      }
    }
    let tabmenu = new tabMenu(tabName.replace('#',''), tabId, tabType);
    tabmenu.tabUrl = '/websystem/plat/wf/wf_list/wflist.jsp';
    tabmenu.componentName = "FrameConComponent";
    let comIns = this.addTabMenu(tabmenu);
    return comIns;//返回 创建的选项卡实例 需要 自取
  }
  /**
   * 创建统一待办列表的标签页
   *
   */
  createWfTodoListTab(){
    //邮件模块 的modtag==13  根据这个去查找 邮件的modid  PS：有可能找不到 找不到时候modid=13
    let tabId = "todo";
    let tabName = "统一待办";
    let tabType = "cpcmod";
    let mods:any;
    if(this.mods&& this.mods.length>0){
      mods = JSON.parse(JSON.stringify(this.mods));
    }
    else{
      mods = JSON.parse(window.sessionStorage.getItem('mods'))?JSON.parse(window.sessionStorage.getItem('mods')).mods:[];
    }


    let item = this.filterItemFromMods(mods,'/websystem/plat/wf/todo_list/wflist.jsp');
    if(item){
      if (item.menuid) {
        tabId = item.menuid;
        tabName = item.menuname;
        tabType = 'cpcmenu';
      } else if (item.modid) {
        tabId = item.modid;
        tabName = item['langmodname'];
        tabType = 'cpcmod';
      }
    }
    let tabmenu = new tabMenu(tabName.replace('#',''), tabId, tabType);
    tabmenu.tabUrl = '/websystem/plat/wf/todo_list/wflist.jsp';
    tabmenu.componentName = "FrameConComponent";
    let comIns = this.addTabMenu(tabmenu);
    return comIns;//返回 创建的选项卡实例 需要 自取
  }

  /**
   * 创建待办任务列表的标签页
   *@param tabname 从首页过来的标题
   */
  createTaskListTab(tabname){

    let taskUrl = "/websystem/bill/pm/PMTaskDetailsSearch.jsp";
    let tabId = "xxx";
    let tabName = tabname;
    let tabType = "cpcindex";
    let mods:any;
    if(this.mods&& this.mods.length>0){
      mods = JSON.parse(JSON.stringify(this.mods));
    }
    else{
      mods = JSON.parse(window.sessionStorage.getItem('mods'))?JSON.parse(window.sessionStorage.getItem('mods')).mods:[];
    }

    let item = this.filterItemFromMods(mods,taskUrl);
    if(item){
      if(item.menuid){
        tabId = item.menuid;
        tabName = item.menuname.replace('#','');
        tabType = "cpcmenu";
      }
      else if(item.modid){
        tabId = item.modid;
        tabName = item['langmodname'].replace('#','');
        tabType = "cpcmod";
      }
    }
    let tabmenu = new tabMenu(tabName, tabId, tabType);
    tabmenu.tabUrl = taskUrl;
    tabmenu.componentName = "FrameConComponent";
    let comIns = this.addTabMenu(tabmenu);
    return comIns;
  }
  /** by 黄秋娟 2022-02-16
   * 递归匹配 模块或者模块菜单的是不是有对应的url 根据url 返回对应的mod或者menu
   *@param items modArray 或者menuArray
   *@param url 根据定义的url 返回对应的mod 或者menu
   */
  filterItemFromMods(items,url) {
    for (let i = 0; i < items.length; i++) {
      let item = items[i];
      //当前模块找到了
      if (item.refaddr.indexOf(url) > -1) {
        return item;
      }
      //继续查找小模块
      else if (item.modofmods && item.modofmods.length>0) {
        item = this.filterItemFromMods(item.modofmods,url);
        if (item) {
          return item;
        }
      }
      //继续查找定义的菜单
      else if(item.menuofmods && item.menuofmods.length>0){
        item = this.filterItemFromMods(item.menuofmods,url);
        if (item) {
          return item;
        }
      }

    }
    return null; //  not found
  }
  ModClick(data: Mod) {
    //menu 是一个对象
    this.selectedMenu.modid = data.modid;
    this.selectedMenu.modname = data['langmodname'];
    this.selectedMenu.modofmods = data.modofmods;
    this.selectedMenu.autoreload = data.autoreload;

    //若模块有关联地址，打开地址。
    if (data.refaddr) {
      const tabmenu = new tabMenu(data['langmodname'].replace('#',''), data.modid.toString(), "cpcmod");
      tabmenu.tabUrl = data.refaddr;
      /**
       * @description 有时候配置一个外链，这时候有可能出现&module= 这时候是不能直接单纯的判断module
       */
      // http://120.24.200.32:8090/sharelink/index.html?shareType=L0t3Bs74wIbDy18jATssn0--Sid-PoVGld+EgM119ABI1iPpXA==&module=flowlinks&entcode=demo
      if ( tabmenu.tabUrl.endsWith("Component") || (tabmenu.tabUrl.indexOf(".module") !== -1 && tabmenu.tabUrl.indexOf("&module") === -1)) {
        tabmenu.componentName = tabmenu.tabUrl;
      }
      else if ( tabmenu.tabUrl.toLocaleLowerCase().indexOf('knowledgebasecomponent') > -1 ) {
        tabmenu.componentName = 'KnowledgeBaseComponent';
      }
      else {
        tabmenu.componentName = "FrameConComponent";
      }
      tabmenu.autoreload = data.autoreload;
      tabmenu.data = data;
      this.addTabMenu(tabmenu);
    }
    this.sLeftMenuSub.next(this.selectedMenu);
  }

  /**
   * 选择标签页(在标签页和下拉标签页中选择,必然是同一对象;若在其他地方，则调用打开新标签页的方法，会在其中处理)
   * @param data
   */
  selectTabMenu(data: tabMenu) {
    (<any>window).refreshLockUser();
    // if(data.componentName === "FrameConComponent" && data.compIns && data.compIns.frame.nativeElement) {
    //   let frameWin = data.compIns.frame.nativeElement.contentWindow;
    //   data.tabUrl.indexOf('')
    //   try{
    //     if( typeof frameWin.doRegQRCode === "function"){
    //       frameWin.doRegQRCode();
    //     }
    //   } catch (e){
    //     console.warn(e);
    //   }
    // }
    if (this.selectedTab != data) {
      this.selectedTab = data;
      let idx = this.selectedQueue.indexOf(data);
      //不用重新排一个队列
      if (idx > -1) {
        this.selectedQueue.splice(idx, 1);
        this.selectedQueue.push(data);
      }
      else {
        this.selectedQueue.push(data);
      }
      this.sTabSub.next(this.selectedTab);

      //更新本地储存的信息
      let sQueue = [];
      for (let iqueue of this.selectedQueue) {
        let si: tabMenu = new tabMenu(iqueue.tabName, iqueue.tabId, iqueue.tabType);
        si.allowClose = iqueue.allowClose;
        si.componentName = iqueue.componentName;
        si.tabUrl = iqueue.tabUrl;
        if (si.componentName == "MenuConComponent") {
          si.menus = iqueue.menus;
        }
        if (si.componentName == "MenuNewConComponent") {
          si.menus = iqueue.menus;
        }
        if (si.componentName == "MenuNew1ConComponent") {
          si.menus = iqueue.menus;
        }
        if (si.componentName == "KnowledgeBaseComponent") {
          si.data = iqueue.data;
        }
        sQueue.push(si);
      }
      window.sessionStorage.setItem('SQueueInfo', JSON.stringify(sQueue));
    }
  }

  /**
   * 新增标签页
   * 调用此方法需New一个tabMenu对象，并传入tabName,tabId,tabType
   * @param data
   */
  addTabMenu(data: tabMenu) {

    let idx = -1;
    for (let i = 0; i < this.TopBar.length; i++) {
      let tobj = this.TopBar[i];
      if (tobj.tabType == data.tabType && tobj.tabId == data.tabId) {
        idx = i;
        break;
      }
    }

    if (idx == -1) {  //需新增
      // 如果是嵌入Delphi 调用Delphi的界面 不需要新增 modtype 或者menutype==4
      if((data&&data.data&& data.data.modtype=='4'&&data.data.refaddr.length>0)
        ||(data&&data.data&& data.data.menutype=='4'&&data.data.refaddr.length>0)){
        let iframe=document.createElement('iframe');
        iframe.src =data.tabUrl;
        iframe.style.display = 'none';
        document.querySelector('body').appendChild(iframe);
        setTimeout(() => {
          document.querySelector('body').removeChild(iframe);
        }, 1500);
        return
      }
      this.selectTabMenu(data);
      this.TopBar.push(data);
      this.TopBarSub.next(this.TopBar); //告诉订阅了this.TopBarSub的对象this.TopBar变化了，需要作出相应处理(新增标签页)

      //更新本地储存的信息
      let sTopBar = [];
      for (let iTopBar of this.TopBar) {
        let si: tabMenu = new tabMenu(iTopBar.tabName, iTopBar.tabId, iTopBar.tabType);
        si.allowClose = iTopBar.allowClose;
        si.componentName = iTopBar.componentName;
        si.tabUrl = iTopBar.tabUrl;
        if (si.componentName == "MenuConComponent") {
          si.menus = iTopBar.menus;
        }
        else if (si.componentName == "MenuNewConComponent") {
          si.menus = iTopBar.menus;
        }
        else if (si.componentName == "MenuNew1ConComponent") {
          si.menus = iTopBar.menus;
        }
        else if (si.componentName == "KnowledgeBaseComponent") {
          si.data = iTopBar.data;
        }
        sTopBar.push(si);
      }
      window.sessionStorage.setItem('TopBarInfo', JSON.stringify(sTopBar));
      return data;

    }
    else {  //无需新增，切换到已存在的标签页
      this.selectTabMenu(this.TopBar[idx]);
      if(this.TopBar[idx].compIns.frame){
        let url = this.TopBar[idx].compIns.frame.nativeElement.src;
        if(data.autoreload && data.autoreload !='false' && data.autoreload !='1'){
          if(url!=data.tabUrl){
            this.TopBar[idx].compIns.srcUrl = '';
            this.TopBar[idx].compIns.srcUrl = this.su.bypassSecurityTrustResourceUrl(data.tabUrl);
          }
        }

      }
      //若组件做了刷新方法，调用刷新
      if (this.TopBar[idx].compIns && this.TopBar[idx].compIns.doRefresh) {
        this.TopBar[idx].compIns.doRefresh();
      }
      //再次打开了，相同的iframe，如果需要自动刷新就刷新  。自动刷新 目前只支持iframe 组件的
      if(this.TopBar[idx].autoreload && this.TopBar[idx].autoreload =='2'){
        if(this.TopBar[idx].compIns.frame){
          let url = this.TopBar[idx].compIns.frame.nativeElement.src;
          this.TopBar[idx].compIns.srcUrl = '';
          this.TopBar[idx].compIns.srcUrl = this.su.bypassSecurityTrustResourceUrl(url);

        }
      }

      return this.TopBar[idx];
    }

  }

  /**
   * 删除标签页
   * @param data
   */
  delTabMenu(data: tabMenu) {
    let idx = this.TopBar.indexOf(data);
    if (idx > -1) {
      this.TopBar.splice(idx, 1);

      let idx2 = this.selectedQueue.indexOf(data);
      if (idx2 > -1)
        this.selectedQueue.splice(idx2, 1);
      if (this.selectedQueue.length > 0)
        this.selectedTab = this.selectedQueue[this.selectedQueue.length - 1];


      this.TopBarSub.next(this.TopBar);

      //更新本地储存的信息
      let sQueue = [];
      for (let iqueue of this.selectedQueue) {
        let si: tabMenu = new tabMenu(iqueue.tabName, iqueue.tabId, iqueue.tabType);
        si.allowClose = iqueue.allowClose;
        si.componentName = iqueue.componentName;
        si.tabUrl = iqueue.tabUrl;
        if (si.componentName == "MenuConComponent") {
          si.menus = iqueue.menus;
        }
        else if(si.componentName == "MenuNewConComponent"){
          si.menus = iqueue.menus;
        }
        else if(si.componentName == "MenuNew1ConComponent"){
          si.menus = iqueue.menus;
        }
        else if (si.componentName == "KnowledgeBaseComponent") {
          si.data = iqueue.data;
        }
        sQueue.push(si);
      }
      window.sessionStorage.setItem('SQueueInfo', JSON.stringify(sQueue));
      //更新本地储存的信息
      let sTopBar = [];
      for (let iTopBar of this.TopBar) {
        let si: tabMenu = new tabMenu(iTopBar.tabName, iTopBar.tabId, iTopBar.tabType);
        si.allowClose = iTopBar.allowClose;
        si.componentName = iTopBar.componentName;
        si.tabUrl = iTopBar.tabUrl;
        if (si.componentName == "MenuConComponent") {
          si.menus = iTopBar.menus;
        }
        else if(si.componentName == "MenuNewConComponent"){
          si.menus = iTopBar.menus;
        }
        else if(si.componentName == "MenuNew1ConComponent"){
          si.menus = iTopBar.menus;
        }
        else if (si.componentName == "KnowledgeBaseComponent") {
          si.data = iTopBar.data;
        }
        sTopBar.push(si);
      }
      window.sessionStorage.setItem('TopBarInfo', JSON.stringify(sTopBar));
    }
  }

  /**
   * 关闭所有标签页
   */
  closeAllTabMenu() {
    if (this.TopBar.length > 0) {
      this.TopBar = this.TopBar.filter(tabmenu => tabmenu.allowClose == false);
      this.TopBarSub.next(this.TopBar);

      this.selectedQueue = this.selectedQueue.filter(tabmenu => tabmenu.allowClose == false);
      this.selectedTab = this.selectedQueue.length > 0 ? this.selectedQueue[this.selectedQueue.length - 1] : null;
      if (this.selectedTab) {
        this.sTabSub.next(this.selectedTab);
      }

      //左侧的left-menu 清除隐藏
      if (this.selectedMenu) {
        this.selectedMenu.modofmods = [];
      }


      //更新本地储存的信息
      let sQueue = [];
      for (let iqueue of this.selectedQueue) {
        let si: tabMenu = new tabMenu(iqueue.tabName, iqueue.tabId, iqueue.tabType);
        si.allowClose = iqueue.allowClose;
        si.componentName = iqueue.componentName;
        si.tabUrl = iqueue.tabUrl;
        if (si.componentName == "MenuConComponent") {
          si.menus = iqueue.menus;
        }
        else if(si.componentName == "MenuNewConComponent"){
          si.menus = iqueue.menus;
        }
        else if(si.componentName == "MenuNew1ConComponent"){
          si.menus = iqueue.menus;
        }
        else if (si.componentName == "KnowledgeBaseComponent") {
          si.data = iqueue.data;
        }

        sQueue.push(si);
      }
      window.sessionStorage.setItem('SQueueInfo', JSON.stringify(sQueue));
      //更新本地储存的信息
      let sTopBar = [];
      for (let iTopBar of this.TopBar) {
        let si: tabMenu = new tabMenu(iTopBar.tabName, iTopBar.tabId, iTopBar.tabType);
        si.allowClose = iTopBar.allowClose;
        si.componentName = iTopBar.componentName;
        si.tabUrl = iTopBar.tabUrl;
        if (si.componentName == "MenuConComponent") {
          si.menus = iTopBar.menus;
        }
        else if(si.componentName == "MenuNewConComponent"){
          si.menus = iTopBar.menus;
        }
        else if(si.componentName == "MenuNew1ConComponent"){
          si.menus = iTopBar.menus;
        }
        else if (si.componentName == "KnowledgeBaseComponent") {
          si.data = iTopBar.data;
        }
        sTopBar.push(si);
      }
      window.sessionStorage.setItem('TopBarInfo', JSON.stringify(sTopBar));
    }
  }

  destroy() {
    this.TopBar.splice(0);
    this.selectedQueue.splice(0);
    this.selectedTab = null;
    this.selectedMenu = new Mod();
    this.IsSpread = true;
    this.docTempOfUsers=[];
    window.sessionStorage.removeItem('TopBarInfo');
    window.sessionStorage.removeItem('SQueueInfo');
    window.sessionStorage.removeItem('docTempInfo');
  }

  /** ------------------------------------ 标签页结束 */

  /**  主模块开始  ------------------------- */

  private mods: Mod[];

  public modMenus: Subject<Mod[]> = new Subject();

  private getModList(modpid: number, modData: Mod[], menuData: Menu[]): Mod[] {
    let mods: Mod[] = [];
    for (let i = 0; i < modData.length; i++)
      if (modData[i].modpid == modpid)
        mods.push(modData[i]);

    for (let i = 0; i < mods.length; i++) {
      mods[i].modofmods = this.getModList(mods[i].modid, modData, menuData);
      mods[i].menuofmods = this.getMenuList(mods[i].modid, 0, menuData);
    }
    return mods;
  }

  private getMenuList(modpid: number, menupid: number, data: Menu[]): Menu[] {
    let menus: Menu[] = [];
    for (let i = 0; i < data.length; i++)
      if (data[i].modid == modpid && data[i].menupid == menupid)
        menus.push(data[i]);

    for (let i = menus.length - 1; i >= 0; i--) {
      menus[i].menuofmenus = this.getMenuList(menus[i].modid, menus[i].menuid, data);
    }
    return menus;
  }

  initMod() {
    this.webapi.post('cpcwebuser', 'getmodandmenu', '')
      .then(
        response => {
          // debugger;
          //console.log(response);
          let userData = response.json();

          // console.log(userData);
          let modofusers: Mod[] = userData.modofusers || [];
          let menuofusers: Menu[] = userData.menuofusers || [];
          this.menuOfUsers = JSON.parse(JSON.stringify(menuofusers));
          let mods = this.getModList(0, modofusers, menuofusers);
          // 文档管理的 文件模板也从这里返回
          this.docTempOfUsers = (userData.doctempofusers && userData.doctempofusers.length) > 0 ? userData.doctempofusers : [];
          window.sessionStorage.setItem('docTempInfo', JSON.stringify(this.docTempOfUsers));
          try {
            window.sessionStorage.setItem('mods', JSON.stringify({
              mods: modofusers,
              menus: menuofusers,
            }));
          } catch (oException) {
            if (oException.name == 'QuotaExceededError') {
              console.log('超出本地存储限额！');
            }
          }
          this.mods = mods;
          this.modMenus.next(this.mods);

          this.check_AutoDispModIds();
        }
      );
  }

  getMod(): Mod[] {
    return this.mods;
  }

  check_AutoDispModIds(){ // 打开时自动加载模块到标签页并打开
    // return new Promise(()=>{
    // debugger;
    if(sessionStorage.getItem('router_path')=='login'){
      let mod=[];
      if(this.sysInfo.AutoDispModIds){ // 打开需要打开的模块及模块下的模块
        let modids:any=this.sysInfo.AutoDispModIds.split(',');
        for(let i=0;i<this.mods.length;i++){ // this.mods[i]，模块
          for(let j=0;j<modids.length;j++){ // modids[j]
            if(this.mods[i].modid==modids[j]){
              this.ModClick(this.mods[i]);
            }
          }
          if(this.mods[i].modofmods && this.mods[i].modofmods.length>0){ // 模块下的模块
            for(let j=0;j<this.mods[i].modofmods.length;j++){ // this.mods[i].modofmods[j]
              for(let k=0;k<modids.length;k++){ // modids[k]
                if(this.mods[i].modofmods[j].modid==modids[k]){
                  this.ModClick(this.mods[i].modofmods[j]);
                }
              }
            }
          }else{}
        }
      }
    }else{}

    // });
    this.check_HideHomePage();
    sessionStorage.setItem('router_path','index');
  }

  check_HideHomePage(){ // 打开后，如果没有隐藏首页，则切换到首页
    // debugger;
    if(Number(this.sysInfo.HideHomePage)!=1 && sessionStorage.getItem('router_path')=='login'){
      for(let i=0;i<this.TopBar.length;i++){ // this.TopBar[i]
        if(this.TopBar[i].tabId=='9999'){
          this.selectTabMenu(this.TopBar[i]);
          break;
        }
      }
    }else{}
  }

  /**  -------------------------------  主模块结束*/

}


export class Mod {
  modid: number; //模块ID
  modname: string; //模块名称
  modcode: string; //模块编码
  modpid: number;  //父模块ID
  isws: boolean = false; //是否为工作区
  refaddr: string;  //关联地址
  modofmods: Mod[] = [];  //子模块
  menuofmods: Menu[] = [];  //子菜单
  isDisplay: boolean = false;
  hint_count_func: string;
  modtype:any;//模块类型 1=DELPHI 2=WEB 3=DELPHI&WEB 4=PLUGIN
  hint_count: string; //别的系统代办的通知
  autoreload: string; //1，不需要自动刷新，2，要自动刷新
  clas:string;
  catname:string;//分组名称
  isShowCatName:boolean;//是否显示分组名称
  modOfCatname:any;//存 分类的mod的
  isShow:boolean;// 当前小模块是否展开
}
export class Menu {
  menuid: number;  //菜单ID
  menuname: string;  //菜单名称
  menucode: string;  //菜单编码
  menupid: number; //父菜单ID
  modid: number; //所属模块ID
  refaddr: string;  //关联地址
  menutype: number;  //菜单类型: 1应用程序；2WEB；3应用程序与WEB
  menuofmenus: Menu[] = []; //子菜单
  autoreload: string ; //1，不需要自动刷新，2，要自动刷新
  catname:string;
}

/**
 * 标签页
 * 目前区分规则：tabType+tabId唯一
 * 显示类型：iframe与component必须有tabSource;menu必须有menus;
 */
export class tabMenu {
  tabName: string;  //标签页名称
  tabType: string;  //标签页类型
  tabId: string;  //标签页关联ID(string是因为可能有加密的id...)
  menus: Menu[];  //可能是子菜单模块里的菜单信息
  tabUrl: string; //标签页关联地址:frame-con-url地址
  componentName: string; //标签页组件名称：componet-组件名称(区分大小写) 使用Iframe:FrameConComponent;菜单:MenuConComponent;其他组件:组件名称
  allowClose: boolean; //允许关闭
  compIns: any; //组件实例(动态创建组件后,将组件实例保存在其中)
  autoreload: string; //tab页 打开的是同一个tab页，如果定义了 自动刷新，就刷新
  data:any;//原始数据
  unNeedLoginguid:boolean; // 不需要会话

  constructor(tabName?: string, tabId?: string, tabType?: string, componentName?: string,autoReload?: string) {
    this.allowClose = true;
    this.tabName = tabName;
    this.tabType = tabType;
    this.tabId = tabId;
    this.componentName = componentName;
    this.autoreload = autoReload;
    // 默认需要会话
    this.unNeedLoginguid = false;
  }
}



// WEBPACK FOOTER //
// D:/cpc/sinocc.web/web.X6/www/x6.ng2/src/app/home-page/mod-menu.service.ts